import React from "react";

export default function ProgressBar({ raised, goal, size = "md" }) {
  const pct = Math.min((raised / goal) * 100, 100);
  const h = size === "lg" ? "h-5" : size === "sm" ? "h-2" : "h-3";

  return (
    <div className={`w-full bg-warm-gray rounded-full ${h} overflow-hidden`}>
      <div
        className={`${h} bg-black rounded-full transition-all duration-700 ease-out`}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
